import React,{useState} from 'react'
import Slider from "react-slick";
import { RiStarFill } from "react-icons/ri";
import { HiArrowRight, HiArrowLeft } from "react-icons/hi";
import Title from '../layouts/Title'
import { testimonialOne,testimonialTwo, testimonialThree, testimonialFour, testimonialFive, testimonialSix, testimonialSeven, quote } from "../../assets/index";


function SampleNextArrow(props) {
  const { onClick } = props;
  return (
    <div
      className="w-14 h-12 bg-[#0c1821] hover:bg-black duration-300 rounded-md text-2xl text-gray-400 flex justify-center items-center absolute top-0 right-0 shadow-shadowOne cursor-pointer z-10"
      onClick={onClick}
    >
      <HiArrowRight />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { onClick } = props;
  return (
    <div
      className="w-14 h-12 bg-[#0c1821] hover:bg-black duration-300 rounded-md text-2xl text-gray-400 flex justify-center items-center absolute top-0 right-20 shadow-shadowOne cursor-pointer z-10"
      onClick={onClick}
    >
      <HiArrowLeft />
    </div>
  );
}

const Testimonial = () => {
      const [dotActive, setDocActive] = useState(0);
     const settings = {
       dots: true,
       infinite: true,
       speed: 500,
       slidesToShow: 1,
       slidesToScroll: 1,
       nextArrow:<SampleNextArrow />,
       prevArrow:<SamplePrevArrow />,
       beforeChange: (prev, next) => {
         setDocActive(next);
       },
       appendDots: (dots) => (
         <div
           style={{
             borderRadius: "10px",
             padding: "10px",
           }}
         >
           <ul
             style={{
               display: "flex",
               gap: "15px",
               justifyContent: "center",
               marginTop: "20px",
             }}
           >
             {" "}
             {dots}{" "}
           </ul>
         </div>
       ),
       customPaging: (i) => (
         <div
           style={
             i === dotActive
               ? {
                   width: "12px",
                   height: "12px",
                   color: "blue",
                   background: "#ff014f",
                   borderRadius: "50%",
                   cursor: "pointer",
                 }
               : {
                   width: "12px",
                   height: "12px",
                   color: "blue",
                   background: "gray",
                   borderRadius: "50%",
                   cursor: "pointer",
                 }
           }
         ></div>
       ),
     };
  return (
    <section
      id="testimonial"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Title title="WHAT CLIENTS SAY" des="Testimonial" />
      </div>
      <div className="max-w-6xl mx-auto">
        <Slider {...settings}>
          {/* ================ Slider Silky Gem ================== */}
          <div className="w-full">
            <div className="w-full h-auto flex flex-col lgl:flex-row justify-between">
              <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-8 rounded-lg shadow-shadowOne flex flex-col md:flex-row lgl:flex-col gap-8 justify-center md:justify-start lgl:justify-center">
                <img
                  className="h-72 md:h-32 lgl:h-72 rounded-lg object-cover"
                  src={testimonialSeven}
                  alt="Silky Gem testimonial"
                />
                <div className="w-full flex flex-col justify-end">
                  <p className="text-xs font-medium uppercase text-designColor tracking-wide mb-2">
                    Silky Gem LLC
                  </p>
                  <h3 className="text-2xl font-bold">Peter Ignat</h3>
                  <p className="text-base tracking-wide text-gray-500">
                    COO, Silky Gem LLC
                  </p>
                </div>
              </div>
              <div className="w-full lgl:w-[60%] h-full flex flex-col justify-between">
                <img className="w-20 lgl:w-32" src={quote} alt="quote" />
                <div className="w-full h-[70%] py-10 bg-gradient-to-r from-[#1e2024] to-[#23272b] rounded-lg shadow-shadowOne p-4 lgl:p-8 flex flex-col justify-center gap-4 lgl:gap-8">
                  <div className="flex flex-col justify-between lgl:items-center py-6 border-b-2 border-b-gray-900">
                    <div>
                      <h3 className="text-xl lgl:text-2xl font-medium tracking-wide">
                        Shopify Plus Performance, UX & Platform Optimization
                      </h3>
                      <p className="text-base text-gray-400 mt-3">
                        Jan 2026 – Present
                      </p>
                    </div>
                    <div className="text-yellow-500 flex gap-1">
                      <RiStarFill />
                      <RiStarFill />
                      <RiStarFill />
                      <RiStarFill />
                      <RiStarFill />
                    </div>
                  </div>
                  <p className="text-base font-titleFont text-gray-400 font-medium tracking-wide leading-6">
                    Brian played a critical role in stabilizing and relaunching our new Shopify Plus Impact theme at Silky Gem. He significantly improved Core Web Vitals, rebuilt our catalog and navigation structure, and optimized hundreds of images without disrupting our live operations. His thorough audits of checkout flows, bundles, subscriptions, and third-party apps gave us a faster, more reliable, and more scalable storefront that our team can confidently build on.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* ================ Slider Six ================== */}
          <div className="w-full">
            <div className="w-full h-auto flex flex-col lgl:flex-row justify-between">
              <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-8 rounded-lg shadow-shadowOne flex flex-col md:flex-row lgl:flex-col gap-8 justify-center md:justify-start lgl:justify-center">
                <img
                  className="h-72 md:h-32 lgl:h-72 rounded-lg object-cover"
                  src={testimonialSix}
                  alt="testimonialSix"
                />
                <div className="w-full flex flex-col justify-end">
                  <p className="text-xs font-medium uppercase text-designColor tracking-wide mb-2">
                    The Shade Shop
                  </p>
                  <h3 className="text-2xl font-bold">Madeline Ferguson</h3>
                  <p className="text-base tracking-wide text-gray-500">
                    Project Manager
                  </p>
                </div>
              </div>
              <div className="w-full lgl:w-[60%] h-full flex flex-col justify-between">
                <img className="w-20 lgl:w-32" src={quote} alt="quote" />
                <div className="w-full h-[70%] py-10 bg-gradient-to-r from-[#1e2024] to-[#23272b] rounded-lg shadow-shadowOne p-4 lgl:p-8 flex flex-col justify-center gap-4 lgl:gap-8">
                  <div className="flex flex-col justify-between lgl:items-center py-6 border-b-2 border-b-gray-900">
                    <div>
                      <h3 className="text-xl lgl:text-2xl font-medium tracking-wide">
                        Ecommerce Platform Optimization
                      </h3>
                      <p className="text-base text-gray-400 mt-3">
                        Oct 2025 - Present
                      </p>
                    </div>
                    <div className="text-yellow-500 flex gap-1">
                      <RiStarFill />
                      <RiStarFill />
                      <RiStarFill />
                      <RiStarFill />
                      <RiStarFill />
                    </div>
                  </div>
                  <p className="text-base font-titleFont text-gray-400 font-medium tracking-wide leading-6">
                    Brian has been instrumental in optimizing our e-commerce platform at The Shade Shop. His comprehensive SEO and performance optimization work has significantly improved our site's search engine visibility and loading speeds. The migration of over 3,500 product and blog images to webp format with accessible alt text has enhanced both our site performance and accessibility. His technical expertise and attention to detail have been exceptional throughout our collaboration.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* ================ Slider Five ================== */}

          <div className="w-full">
            <div className="w-full h-auto flex flex-col lgl:flex-row justify-between">
              <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-8 rounded-lg shadow-shadowOne flex flex-col md:flex-row lgl:flex-col gap-8 justify-center md:justify-start lgl:justify-center">
                <img
                  className="h-72 md:h-32 lgl:h-72 rounded-lg object-cover"
                  src={testimonialFive}
                  alt="testimonialFive"
                />
                <div className="w-full flex flex-col justify-end">
                  <p className="text-xs font-medium uppercase text-designColor tracking-wide mb-2">
                    TimeNough Inc
                  </p>
                  <h3 className="text-2xl font-bold">Arnaud Lagardere</h3>
                  <p className="text-base tracking-wide text-gray-500">
                    CTO & Co-Founder
                  </p>
                </div>
              </div>
              <div className="w-full lgl:w-[60%] h-full flex flex-col justify-between">
                <img className="w-20 lgl:w-32" src={quote} alt="quote" />
                <div className="w-full h-[70%] py-10 bg-gradient-to-r from-[#1e2024] to-[#23272b] rounded-lg shadow-shadowOne p-4 lgl:p-8 flex flex-col justify-center gap-4 lgl:gap-8">
                  <div className="flex flex-col justify-between lgl:items-center py-6 border-b-2 border-b-gray-900">
                    <div>
                      <h3 className="text-xl lgl:text-2xl font-medium tracking-wide">
                        Investor Relations & Full Stack Development Partnership
                      </h3>
                      <p className="text-base text-gray-400 mt-3">
                        Feb 2022 – Jan 2026
                      </p>
                    </div>
                    <div className="text-yellow-500 flex gap-1">
                      <RiStarFill />
                      <RiStarFill />
                      <RiStarFill />
                      <RiStarFill />
                      <RiStarFill />
                    </div>
                  </div>
                  <p className="text-base font-titleFont text-gray-400 font-medium tracking-wide leading-6">
                    Brian has been an exceptional dual-role partner at TimeNough Inc, seamlessly combining strategic investor relations support with expert full-stack development leadership. His technical architecture of our enterprise SaaS platform for time tracking and productivity has been transformative, delivering machine learning–driven analytics and scalable cloud solutions that significantly enhanced our product offering. Beyond the technical excellence, his investor communications and fundraising coordination provided crucial strategic guidance during our key growth phases. His ability to bridge business strategy with cutting-edge engineering made him an indispensable asset to our team's success.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* ================ Slider Four ================== */}

          <div className="w-full">
            <div className="w-full h-auto flex flex-col lgl:flex-row justify-between">
              <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-8 rounded-lg shadow-shadowOne flex flex-col md:flex-row lgl:flex-col gap-8 justify-center md:justify-start lgl:justify-center">
                <img
                  className="h-72 md:h-32 lgl:h-72 rounded-lg object-cover"
                  src={testimonialFour}
                  alt="testimonialFour"
                />
                <div className="w-full flex flex-col justify-end">
                  <p className="text-xs font-medium uppercase text-designColor tracking-wide mb-2">
                    Training Ties
                  </p>
                  <h3 className="text-2xl font-bold">Robert Morong</h3>
                  <p className="text-base tracking-wide text-gray-500">
                    Founder & CEO
                  </p>
                </div>
              </div>
              <div className="w-full lgl:w-[60%] h-full flex flex-col justify-between">
                <img className="w-20 lgl:w-32" src={quote} alt="quote" />
                <div className="w-full h-[70%] py-10 bg-gradient-to-r from-[#1e2024] to-[#23272b] rounded-lg shadow-shadowOne p-4 lgl:p-8 flex flex-col justify-center gap-4 lgl:gap-8">
                  <div className="flex flex-col justify-between lgl:items-center py-6 border-b-2 border-b-gray-900">
                    <div>
                      <h3 className="text-xl lgl:text-2xl font-medium tracking-wide">
                        Shopify Store Optimization & CRO
                      </h3>
                      <p className="text-base text-gray-400 mt-3">
                        via Contract - Sep 2025 - Sep 2025
                      </p>
                    </div>
                    <div className="text-yellow-500 flex gap-1">
                      <RiStarFill />
                      <RiStarFill />
                      <RiStarFill />
                      <RiStarFill />
                      <RiStarFill />
                    </div>
                  </div>
                  <p className="text-base font-titleFont text-gray-400 font-medium tracking-wide leading-6">
                    Brian transformed our Shopify store with incredible attention to detail. The cart and checkout redesign, mobile responsiveness updates, and custom popup modals significantly improved our user journey. His A/B testing approach and conversion-focused improvements provided exactly what we needed to boost our conversion rates. Professional, efficient, and results-driven!
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          {/* ================ Slider Three ================== */}

          <div className="w-full">
            <div className="w-full h-auto flex flex-col lgl:flex-row justify-between">
              <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-8 rounded-lg shadow-shadowOne flex flex-col md:flex-row lgl:flex-col gap-8 justify-center md:justify-start lgl:justify-center">
                <img
                  className="h-72 md:h-32 lgl:h-72 rounded-lg object-cover"
                  src={testimonialThree}
                  alt="testimonialThree"
                />
                <div className="w-full flex flex-col justify-end">
                  <p className="text-xs font-medium uppercase text-designColor tracking-wide mb-2">
                    Groundwork Coffee
                  </p>
                  <h3 className="text-2xl font-bold">Robert Petersen</h3>
                  <p className="text-base tracking-wide text-gray-500">
                    Production Manager
                  </p>
                </div>
              </div>
              <div className="w-full lgl:w-[60%] h-full flex flex-col justify-between">
                <img className="w-20 lgl:w-32" src={quote} alt="quote" />
                <div className="w-full h-[70%] py-10 bg-gradient-to-r from-[#1e2024] to-[#23272b] rounded-lg shadow-shadowOne p-4 lgl:p-8 flex flex-col justify-center gap-4 lgl:gap-8">
                  <div className="flex flex-col justify-between lgl:items-center py-6 border-b-2 border-b-gray-900">
                    <div>
                      <h3 className="text-xl lgl:text-2xl font-medium tracking-wide">
                        Shopify Enhancements & Product Optimization
                      </h3>
                      <p className="text-base text-gray-400 mt-3">
                        via Contract - Feb 2025 - Feb 2025
                      </p>
                    </div>
                    <div className="text-yellow-500 flex gap-1">
                      <RiStarFill />
                      <RiStarFill />
                      <RiStarFill />
                      <RiStarFill />
                      <RiStarFill />
                    </div>
                  </div>
                  <p className="text-base font-titleFont text-gray-400 font-medium tracking-wide leading-6">
                    Brian delivered exceptional Shopify enhancements that transformed our coffee storefront. His custom feature implementations, including the 'Sold Out' inventory system and Recharge subscription integration, streamlined our operations significantly. The café location management and PDP image optimizations created a much cleaner, more intuitive customer experience. Outstanding technical expertise!
                  </p>
                </div>
              </div>
            </div>
          </div>
          
        {/* ================ Slider One ================== */}

          <div className="w-full">
            <div className="w-full h-auto flex flex-col lgl:flex-row justify-between">
              <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-8 rounded-lg shadow-shadowOne flex flex-col md:flex-row lgl:flex-col gap-8 justify-center md:justify-start lgl:justify-center">
                <img
                  className="h-72 md:h-32 lgl:h-72 rounded-lg object-cover"
                  src={testimonialOne}
                  alt="testimonialOne"
                />
                <div className="w-full flex flex-col justify-end">
                  <p className="text-xs font-medium uppercase text-designColor tracking-wide mb-2">
                    Aran Woollen Mills
                  </p>
                  <h3 className="text-2xl font-bold">Laura Egan</h3>
                  <p className="text-base tracking-wide text-gray-500">
                    Brand Manager
                  </p>
                </div>
              </div>
              <div className="w-full lgl:w-[60%] h-full flex flex-col justify-between">
                <img className="w-20 lgl:w-32" src={quote} alt="quote" />
                <div className="w-full h-[70%] py-10 bg-gradient-to-r from-[#1e2024] to-[#23272b] rounded-lg shadow-shadowOne p-4 lgl:p-8 flex flex-col justify-center gap-4 lgl:gap-8">
                  <div className="flex flex-col justify-between lgl:items-center py-6 border-b-2 border-b-gray-900">
                    <div>
                      <h3 className="text-xl lgl:text-2xl font-medium tracking-wide">
                        Shopify Plus D2C Transformation
                      </h3>
                      <p className="text-base text-gray-400 mt-3">
                        via Cake Agency - June 2024 - July 2024
                      </p>
                    </div>
                    <div className="text-yellow-500 flex gap-1">
                      <RiStarFill />
                      <RiStarFill />
                      <RiStarFill />
                      <RiStarFill />
                      <RiStarFill />
                    </div>
                  </div>
                  <p className="text-base font-titleFont text-gray-400 font-medium tracking-wide leading-6">
                    Cake's expertise and strategic advice has been paramount to our successful journey to date - the team have been a tremendous support. 
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* ================ Slider Two ================== */}

          <div className="w-full">
            <div className="w-full h-auto flex flex-col lgl:flex-row justify-between">
              <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-8 rounded-lg shadow-shadowOne flex flex-col md:flex-row lgl:flex-col gap-8 justify-center md:justify-start lgl:justify-center">
                <img
                  className="h-72 md:h-32 lgl:h-72 rounded-lg object-cover"
                  src={testimonialTwo}
                  alt="testimonialTwo"
                />
                <div className="w-full flex flex-col justify-end">
                  <p className="text-xs font-medium uppercase text-designColor tracking-wide mb-2">
                    P&Co Fashion
                  </p>
                  <h3 className="text-2xl font-bold">Brendan Holmsfield</h3>
                  <p className="text-base tracking-wide text-gray-500">
                    Financial Director
                  </p>
                </div>
              </div>
              <div className="w-full lgl:w-[60%] h-full flex flex-col justify-between">
                <img className="w-20 lgl:w-32" src={quote} alt="quote" />
                <div className="w-full h-[70%] py-10 bg-gradient-to-r from-[#1e2024] to-[#23272b] rounded-lg shadow-shadowOne p-4 lgl:p-8 flex flex-col justify-center gap-4 lgl:gap-8">
                  <div className="flex flex-col justify-between lgl:items-center py-6 border-b-2 border-b-gray-900">
                    <div>
                      <h3 className="text-xl lgl:text-2xl font-medium tracking-wide">
                        Loyalty Program & Email Marketing
                      </h3>
                      <p className="text-base text-gray-400 mt-3">
                        via Cake Agency - Aug 2024 - Aug 2024
                      </p>
                    </div>
                    <div className="text-yellow-500 flex gap-1">
                      <RiStarFill />
                      <RiStarFill />
                      <RiStarFill />
                      <RiStarFill />
                      <RiStarFill />
                    </div>
                  </div>
                  <p className="text-base font-titleFont text-gray-400 font-medium tracking-wide leading-6">
                    Working with Brian was game-changing for our 460k+ follower brand. He designed a sophisticated loyalty program that got 18,347 customers enrolled and increased our AOV by 13%. The Klaviyo automation and tiered rewards system delivered a 28% conversion improvement. His technical expertise and strategic thinking are unmatched.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    </section>
  );
}

export default Testimonial